import type { ActingParty } from "../types/involvement.js";
import type { CustomerRole } from "../types/thalamos.js";

/**
 * Whether a role administers its organisation's person records. Keyed by role
 * so a new one has to say.
 */
const administersByRole: Record<CustomerRole, boolean> = {
  organisation_admin: true,
  responsible_user: false,
  assessor: false,
  approver: false,
  viewer: false,
};

export const isPartyActingAsOrganisationAdmin = (
  party: Pick<ActingParty, "roles">,
): boolean => party.roles.some((role) => administersByRole[role]);
